export class Document {
  public isFolder: boolean;
  public name = '';
  public path = '';
}
